import { ProfileScreen } from "../screens/account/ProfileScreen";
import { ResetPasswordScreen } from "../screens/account/ResetPasswordScreen";
import { AllTimeScreen } from "../screens/dashboard/AllTimeScreen";
import { AnalyticsScreen } from "../screens/dashboard/AnalyticsScreen";
import { BalanceDetailScreen } from "../screens/dashboard/BalanceDetailScreen";
import { DailySaleScreen } from "../screens/dashboard/DailySaleScreen";
import { DashboardScreen } from "../screens/dashboard/DashboardScreen";
import { FBLCenterScreen } from "../screens/dashboard/FBLCenterScreen";
import { HoldDetailScreen } from "../screens/dashboard/HoldDetailScreen";
import PlaygroundScreen from "../screens/PlaygroundScreen";

export const OtherRoutes = [
  { path: "/", exact: true, component: DashboardScreen },
  { path: "/analytics", exact: true, component: AnalyticsScreen },
  { path: "/dashboard/fbl", exact: true, component: FBLCenterScreen },
  { path: "/dashboard/day", exact: true, component: DailySaleScreen },
  { path: "/dashboard/day/:id", exact: true, component: DailySaleScreen },
  { path: "/dashboard/day/:type", exact: true, component: DailySaleScreen },
  { path: "/dashboard/day/:id/:type", exact: true, component: DailySaleScreen },
  { path: "/dashboard/alltime", exact: true, component: AllTimeScreen },
  { path: "/dashboard/alltime/:type", exact: true, component: AllTimeScreen },
  { path: "/dashboard/hold", exact: true, component: HoldDetailScreen }, // Deprecated
  { path: "/dashboard/balance", exact: true, component: BalanceDetailScreen }, // Deprecated
  { path: "/account/profile", exact: true, component: ProfileScreen },
  { path: "/account/resetpassword", exact: true, component: ResetPasswordScreen },
  { path: "/playground", exact: true, component: PlaygroundScreen },
  { path: "/playground/:id", exact: true, component: PlaygroundScreen },
];
